import { dequal } from 'dequal';
import { useState } from 'react';
import { useRecoilValueLoadable } from 'recoil';
/**
 * This hooks provides stable access to any generic state.
 * It will persist the current value while the state is pending.
 * Can be used for non-service based derived state.
 *
 * @template T
 * @param {RecoilValue<T>} genericState
 * @param {T} [defaultValue]
 * @returns
 */
export const useGetState = (genericState, defaultValue) => {
    const [currentState, setState] = useState(defaultValue);
    const responseLoadable = useRecoilValueLoadable(genericState);
    if (responseLoadable.state === 'hasValue') {
        const newState = responseLoadable.contents;
        if (!dequal(currentState, newState)) {
            setState(newState);
        }
    }
    return currentState;
};
export default useGetState;
//# sourceMappingURL=use-get-state.js.map